export default {
    helpText:
        'Users must have a verified Primary Email address to become Owner.',
    label: 'Owner',
    subtitle: 'Transfer the ownership of this company to another user',
    title: 'Transfer Ownership',
};
